module.exports = __webpack_public_path__ + "static/media/28DGC11.d411ba43.jpg";